export default "__VITE_ASSET__CsGBhPls__"